import { APICfg } from 'services/api/api'
import { APIBaseProduct } from '../baseProduct/types/api/response-models'
import { ProductSection, ProductSectionToAPI } from '../types'
import { productSectionParse } from '../utils'

type RentSection = ProductSection<APIBaseProduct>

type RentSectionToApi = ProductSectionToAPI

const apiCfg: APICfg = {
  endpoint: 'rentsections',
  parse: productSectionParse,
  write: async (req: RentSection): Promise<RentSectionToApi> => req,
}
export default apiCfg
